import { SET_THEME, SET_CHAT_THEME } from '../types/theme.type'

const intialState = {
  activeTheme: '',
  activeChatTheme: 'theme5',
}
const themeReducer = (state = intialState, action) => {
  switch (action.type) {
    case SET_CHAT_THEME: {
      return {
        ...state,
        activeChatTheme: action.payload,
      }
    }
    case SET_THEME: {
      return {
        ...state,
        activeTheme: action.payload,
      }
    }
    default:
      return state
  }
}

export default themeReducer
